<template>
  <v-dialog v-model="dialogOpen" width="500" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" x-small color="secondary">ADD HARDWARE</v-btn>
    </template>

    <v-card>
      <v-card-title>Bring your own hardware</v-card-title>
      <v-card-text>
        <v-select v-model="currentHardware" :items="availableHardwareSelect" :no-data-text="noDataText" item-text="name" item-value="id" label="Select Hardware" return-object multiple hide-details outlined dense>
          <template v-slot:selection="{ index }">
            <span v-if="index===0">{{ currentHardware.length }} Items Selected</span>
          </template>
        </v-select>
      </v-card-text>
      
      <v-card-text>
        <v-row v-for="(item, i) in currentHardware" :key="`hw-edit-${i}`">
          <v-col>
            <v-card>
              <v-card-text>
                <div>
                  <span class="d-flex subtitle-2 mb-2">{{ item.name }}</span>
                  <v-text-field v-model.number="item.quantity" label="Quantity" type="number" dense outlined></v-text-field>
                </div>

                <div v-for="(quantity, q) in item.quantity" :key="q">
                  <v-text-field v-model="item.mac_addresses[q]" :label="`Item ${q + 1} - mac address`" dense outlined></v-text-field>
                </div>

                <span v-if="!$v.currentHardware.$each[i].quantity.minValue" class="error--text">*Item will be removed after saving</span>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submit(currentHardware)" :disabled="getUpdateProductHardwareLoading" :loading="getUpdateProductHardwareLoading">SAVE</v-btn>
        <v-btn color="primary" small outlined :disabled="getUpdateProductHardwareLoading" @click="close">CLOSE</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { validationMixin } from "vuelidate";
import { required, minValue } from "vuelidate/lib/validators";

export default {
  mixins: [ validationMixin ],

  validations: {
    currentHardware: {
      $each: {
        quantity: { minValue: minValue(1) }
      }
    }
  },

  data() {
    return {
      dialogOpen: false,
      loading: false,
      availableHardwareSelect: [],
      currentHardware: [],
    }
  },

  computed: {
    ...mapState('products',['currentProduct']),
    ...mapGetters('productHardware', ['getAvailableHardware', 'getAvailableHardwareLoading', 'getAvailableHardwareError', 'getProductHardware', 'getUpdateProductHardwareLoading']),

    noDataText() {
      if(this.getAvailableHardwareError) {
        return "Error loading this component."
      } 
    }
  },

  watch: {
    getAvailableHardware(newVal) {
      if(newVal) {
        let compare = (a,b)=>{
          const itemA = a.name.toUpperCase();const itemB = b.name.toUpperCase();let comparison = 0;
          if(itemA>itemB){comparison=1;}else if(itemA<itemB){comparison=-1;}
          return comparison;
        }
        this.availableHardwareSelect = this.getAvailableHardware.map(e => ({ name: `${e.name} - ${this.titleCase(e.availability)}`, id: e.id, quantity: 1, mac_addresses: [] }));
        this.availableHardwareSelect.sort(compare);
      }
    },

    getProductHardware(newVal) {
      if(newVal) {
        this.currentHardware = Object.values(this.getProductHardware).map(e=>e);
      }
    }
  },

  methods: {
    ...mapActions('productHardware', ['resetDefaultRef', 'updateProductHardware']),
    ...mapActions('upfrontcosts',['fetchUpfrontCostsById']),
    titleCase(str) {
      if(str===''){ return ''; }
      return str.toLowerCase().split(' ').map(function(word) {
        return word.replace(word[0], word[0].toUpperCase());
      }).join(' ');
    },
    async submit(currentHardware) {
      const payload = currentHardware.reduce((acc, obj) => {
        if(obj.quantity) {
          for(let i = 0; i < obj.quantity; i++) {
            acc.push({ voip_device_model_id: obj.id, mac_address: obj.mac_addresses[i] });
          }
        } 
        return acc;
      }, []);
      
      try {
        await this.updateProductHardware({productId: this.currentProduct.id, payload });
        await this.fetchUpfrontCostsById(this.currentProduct.id);
        this.close();
      } catch(err) {
        return err;
      }
    },

    close() {
      this.dialogOpen = false;
      this.resetDefaultRef();
    },
  },
}
</script>

<style lang="scss" scoped></style>
